<template>
    <div class="go-to-top" @click="paraTopo()">
        <i class="fa fa-arrow-circle-up fa-3x" aria-hidden="true"></i>
    </div>
</template>

<script>
export default {
    name: "IrParaTopo",
    methods: {
        paraTopo () {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        },
        handleScroll () {
            const element = document.querySelector(".go-to-top")
            if (element.style.right !== "15px") {
                if (window.scrollY > 200) {
                    element.style.right = "20px"
                    setTimeout(() => {
                        element.style.right = "15px"
                    }, 100)
                }
            } else {
                if (window.scrollY < 200) {
                    element.style.right = "20px"
                    setTimeout(() => {
                        element.style.right = "-45px"
                    }, 100)
                }
            }
        }
    },
    created () {
        window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll)
    },
}
</script>

<style scoped>
.go-to-top {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    right: -45px;
    bottom: 15px;
    cursor: pointer;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.75);
    transition: 0.1s;
}
</style>



// WEBPACK FOOTER //
// index.vue?bec7aeec